import { render, staticRenderFns } from "./EditBact.vue?vue&type=template&id=4b8b3953&scoped=true"
import script from "./EditBact.vue?vue&type=script&lang=js"
export * from "./EditBact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8b3953",
  null
  
)

export default component.exports